import DeviceUtils from '../device_utils';

class Mojobox {
  #price;

  constructor(account) {
    this.#price = account.mojobox_unit_price / 100;
  }

  getPrice() {
    return this.#price;
  }

  // Show price for monthly payment plan in case of 36 months selected
  formatPriceForShopfront(price) {
    return (price / 36).toFixed(2);
  }

  printFormattedPrice() {}

  toggleCodeboxNote() {
    DeviceUtils.hideCodeboxNumberZone();
  }

  toggleAddressBehavior() {
    DeviceUtils.showCanadian();
  }
}

export default Mojobox;
